package co.maytes.standupbot.dashboard.features.settings

fun parseHoldBackLabels(text: String): List<String> =
    text.split(',', '\n')
        .map { it.trim().lowercase() }
        .filter { it.isNotEmpty() }
        .distinct()
